import { render, staticRenderFns } from "./availableitem.vue?vue&type=template&id=21503bc1&scoped=true&"
import script from "./availableitem.vue?vue&type=script&lang=js&"
export * from "./availableitem.vue?vue&type=script&lang=js&"
import style0 from "./availableitem.vue?vue&type=style&index=0&id=21503bc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21503bc1",
  null
  
)

export default component.exports